import { useState } from "react";
import {
  TextField,
  MenuItem,
  FormControl,
  Stack,
  InputAdornment,
  IconButton,
  Modal,
  Box,
  Typography,
  Select,
  InputLabel,
  ListItemText
} from "@mui/material";
import { useSelector } from "react-redux";
import { Postrequestcall } from "../../request/Postrequest";
import { FETCH_PROVINCES, SAVE_COMPANIES_ADDRESS } from "../../constant/Apipath";
import { Autocomplete as GooglePlacesAutocomplete } from "@react-google-maps/api";
import { English } from "../../constant/EnglishFallback";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 0;

const MenuProps = {
  PaperProps: {
    style: {
      maxWidth: ITEM_HEIGHT + ITEM_PADDING_TOP,
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: "auto"
    }
  },
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "center"
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "center"
  },
  variant: "menu"
};

const AddContactInfo = ({ open, onClose, from, data, onDataSave }) => {
  const { loginData, multiLanguageData } = useSelector((state) => state?.main);
  const currentUserId = loginData?.userInformation?.UserId ?? 0;

  const countries = ["Canada", "United Kingdom", "United States"];

  const [address, setAddress] = useState("");
  const [apartment, setApartment] = useState("");
  const [city, setCity] = useState("");
  const [province, setProvince] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [country, setCountry] = useState("");
  const [contactPerson, setContactPerson] = useState("");
  const [contactPhone, setContactPhone] = useState("");
  const [contactEmail, setContactEmail] = useState("");
  const [submitLoading, setSubmitLoading] = useState(false);
  const [provinceList, setProvinceList] = useState([]);
  const [autocomplete, setAutocomplete] = useState(null);

  const {
    TEXT_ADD_ADDRESS_TITLE = English?.AddAddress?.TEXT_ADD_ADDRESS_TITLE,
    TEXT_ADD_CONTACT_INFO_TITLE = English?.AddContactInfo?.TEXT_ADD_CONTACT_INFO_TITLE,
    TEXT_SELECT_COUNTRY = English?.AddAddress?.TEXT_SELECT_COUNTRY,
    TEXT_ADDRESS = English?.AddAddress?.TEXT_ADDRESS,
    TEXT_APARTMENT_SUITE_ETC = English?.AddAddress?.TEXT_APARTMENT_SUITE_ETC,
    TEXT_CITY_PLACEHOLDER = English?.AddAddress?.TEXT_CITY_PLACEHOLDER,
    TEXT_PROVIENCE = English?.AddAddress?.TEXT_PROVIENCE,
    TEXT_STATE = English?.AddAddress?.TEXT_STATE,
    TEXT_POSTAL_CODE = English?.AddAddress?.TEXT_POSTAL_CODE,
    TEXT_POSTCODE = English?.AddAddress?.TEXT_POSTCODE,
    TEXT_ZIP_CODE_LABEL = English?.AddAddress?.TEXT_ZIP_CODE_LABEL,
    TEXT_CONTACT_PERSON = English?.AddContactInfo?.TEXT_CONTACT_PERSON,
    TEXT_CONTACT_PHONE = English?.AddContactInfo?.TEXT_CONTACT_PHONE,
    TEXT_CONTACT_EMAIL = English?.AddContactInfo?.TEXT_CONTACT_EMAIL
  } = multiLanguageData?.AddAddress || multiLanguageData?.AddContactInfo || {};

  const getSaveObj = () => {
    let saveObject = {
      userId: Number(currentUserId),
      ReturnRecordId: true,
      ReturnRecordError: true,
      SaveList: []
    };

    if (from === "company" || from === "manufacture") {
      return {
        ...saveObject,
        SaveList: [
          {
            Id: 0,
            Type: "Main",
            CompanyId: data?.id,
            Address: address,
            City: city,
            Province: province,
            PostalCode: postalCode,
            Country: country,
            ContactPerson: contactPerson.trim(),
            Phone: contactPhone.trim(),
            Email: contactEmail.trim(),
            ModifiedBy: Number(currentUserId),
            RecordStatusId: 1,
            Manufacturer: from === "company" ? false : true
          }
        ]
      };
    }
  };

  const getApiUrl = () => {
    let apiUrl = "";
    if (from === "company" || from === "manufacture") {
      apiUrl = SAVE_COMPANIES_ADDRESS;
    }
    return apiUrl;
  };

  const onSubmit = async (e) => {
    try {
      e.preventDefault();
      setSubmitLoading(true);
      let obj = getSaveObj();
      await Postrequestcall(getApiUrl(), obj, loginData?.accessToken);
      onClose();
      onDataSave();
    } catch (error) {
      console.log("onSubmit-> Error while Saving Address & Contact: ", error);
      onClose();
    } finally {
      setSubmitLoading(false);
    }
  };

  const getProviencesList = async (country) => {
    try {
      const obj = {
        PageNr: 1,
        FullSearch: "",
        IncludeRecordNr: false,
        NrOfRecPerPage: 50,
        SearchList: [
          {
            Country: country === "United States" ? "USA" : country
          }
        ]
      };
      const res = await Postrequestcall(FETCH_PROVINCES, obj, loginData?.accessToken);
      setProvinceList(res?.data?.data ?? []);
    } catch (error) {
      console.log("getProviencesList-> Error While Getting Provinces List: ", error);
    }
  };

  async function handleSearch() {
    let place = autocomplete.getPlace();
    if (place?.address_components) {
      const street =
        place?.address_components.find((address) => address.types.includes("street_number"))
          ?.long_name ?? "";
      const route =
        place?.address_components.find((address) => address.types.includes("route"))?.long_name ??
        "";
      setCity(
        place?.address_components.find((address) => address.types.includes("locality"))
          ?.long_name ?? ""
      );
      setProvince(
        place?.address_components.find((address) =>
          address.types.includes("administrative_area_level_1")
        )?.long_name ?? ""
      );
      setCountry(
        place?.address_components.find((address) => address.types.includes("country"))?.long_name ??
          ""
      );
      setAddress(place?.street != "" ? street + " " + route : route);
      setPostalCode(
        place?.address_components.find((address) => address.types.includes("postal_code"))
          ?.long_name ?? ""
      );
    }
  }

  const getComponentRestrictions = () => {
    if (country?.toLowerCase() == "usa" || country?.toLowerCase() == "united states") {
      return { country: ["US"] };
    } else if (country?.toLowerCase() == "uk" || country?.toLowerCase() == "united kingdom") {
      return { country: ["GB"] };
    } else {
      return { country: ["CA"] };
    }
  };
  const handleCountryChange = (e) => {
    let inputValue = e.target.value;
    inputValue = inputValue.replace(/^[^A-Za-z0-9]+/, "");
    setCountry(inputValue);
    getProviencesList(inputValue);
    setAddress("");
    setCity("");
    setPostalCode("");
    setApartment("");
  };
  const handleKeyDown = (e) => {
    // If the input is empty and the key is not alphanumeric, block it
    if (
      address.length === 0 &&
      !/^[A-Za-z0-9]$/.test(e.key) &&
      e.key.length === 1 // Only block printable characters
    ) {
      e.preventDefault();
    }
  };

  return (
    <Modal open={open}>
      <Box className="user-modal-responsive">
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between"
          }}>
          <Typography variant="h6" ml={1}>
            {TEXT_ADD_CONTACT_INFO_TITLE}
          </Typography>
          <Stack flexDirection={"row"}>
            <IconButton onClick={() => onClose()}>
              <CloseIcon />
            </IconButton>
            <IconButton
              color="primary"
              loading={submitLoading}
              variant="contained"
              onClick={onSubmit}
              disabled={address?.trim() === "" || postalCode?.trim() === "" || !country}>
              <SaveIcon />
            </IconButton>
          </Stack>
        </Box>
        <Stack spacing={1.5} pt={1}>
          <FormControl variant="outlined" fullWidth>
            <TextField
              select
              label={TEXT_SELECT_COUNTRY}
              value={country}
              onChange={(e) => {
                handleCountryChange(e);
              }}>
              {countries.map((c, i) => (
                <MenuItem key={i} value={c}>
                  {c}
                </MenuItem>
              ))}
            </TextField>
          </FormControl>
          <GooglePlacesAutocomplete
            onLoad={(newInstance) => {
              setAutocomplete(newInstance);
            }} // Sets instance of Autocomplete to be referenced
            onPlaceChanged={handleSearch}
            options={{
              // componentRestrictions:{ country: ['US', 'CA', 'GB'] }, // Restrict to USA, Canada, and UK
              componentRestrictions: getComponentRestrictions()
            }}>
            <TextField
              variant="outlined"
              placeholder={TEXT_ADDRESS}
              fullWidth
              value={address}
              onChange={(event) => {
                let inputValue = event.target.value;
                inputValue = inputValue.replace(/^[^A-Za-z0-9]+/, "");
                setAddress(inputValue);
              }}
              onKeyDown={handleKeyDown}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    {address !== "" ? (
                      <IconButton
                        onClick={() => {
                          setAddress("");
                          setCity("");
                          setProvince("");
                          setPostalCode("");
                          setApartment("");
                        }}>
                        <CloseIcon />
                      </IconButton>
                    ) : (
                      <></>
                    )}
                  </InputAdornment>
                )
              }}
            />
          </GooglePlacesAutocomplete>
          <TextField
            label={TEXT_APARTMENT_SUITE_ETC}
            variant="outlined"
            fullWidth
            value={apartment}
            onChange={(e) => {
              let inputValue = e.target.value;
              inputValue = inputValue.replace(/^[^A-Za-z0-9]+/, "");
              setApartment(inputValue);
            }}
          />

          <TextField
            label={TEXT_CITY_PLACEHOLDER}
            variant="outlined"
            fullWidth
            value={city}
            onChange={(e) => {
              let inputValue = e.target.value;
              inputValue = inputValue.replace(/^[^A-Za-z0-9]+/, "");
              setCity(inputValue);
            }}
          />
          {country !== "United Kingdom" && provinceList?.length > 0 ? (
            <FormControl size="medium" fullWidth>
              <InputLabel id="mutiple-select-label">
                {country == "Canada" ? TEXT_PROVIENCE : TEXT_STATE}
              </InputLabel>
              <Select
                labelId="mutiple-select-label"
                variant="outlined"
                value={province}
                label={country == "Canada" ? TEXT_PROVIENCE : TEXT_STATE}
                onChange={(e) => setProvince(e.target.value)}
                MenuProps={MenuProps}
                sx={{ p: 0 }}>
                {provinceList.map((option, index) => {
                  return (
                    <MenuItem key={index} value={option.province}>
                      <ListItemText primary={option.province} />
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          ) : null}

          <TextField
            label={
              country == "Canada"
                ? TEXT_POSTAL_CODE
                : country == "United Kingdom"
                  ? TEXT_POSTCODE
                  : TEXT_ZIP_CODE_LABEL
            }
            variant="outlined"
            fullWidth
            value={postalCode}
            onChange={(e) => {
              let inputValue = e.target.value;
              inputValue = inputValue.replace(/^[^A-Za-z0-9]+/, "");
              setPostalCode(inputValue.toUpperCase());
            }}
          />

          <TextField
            label={TEXT_CONTACT_PERSON}
            variant="outlined"
            fullWidth
            value={contactPerson}
            onChange={(e) => setContactPerson(e.target.value)}
          />
          <TextField
            label={TEXT_CONTACT_PHONE}
            variant="outlined"
            fullWidth
            value={contactPhone}
            onChange={(e) => {
              let inputValue = e.target.value.replace(/[^A-Za-z0-9 ()+-]/g, "");
              setContactPhone(inputValue);
            }}
          />
          <TextField
            label={TEXT_CONTACT_EMAIL}
            variant="outlined"
            fullWidth
            type="email"
            value={contactEmail}
            onChange={(e) => setContactEmail(e.target.value)}
          />
        </Stack>
      </Box>
    </Modal>
  );
};

export default AddContactInfo;
